module.exports = __webpack_public_path__ + "assets/new.8a69ec49.svg";